const globalVar = {
  galleryTimeout: 5000,
};

export default globalVar;
